// extracted by mini-css-extract-plugin
export default {"wrapper":"YtAhxR5M_7"};